import http from "@/http/aisea/axios";
const resource = "/hull_insurance/enterprises/statistics";

export default {
  fetch() {
    return http.get(`${resource}`);
  },
};
